import { ControllerProps, ControllerRenderProps } from "react-hook-form";

import { countrySpecificFields } from "checkout-experience/utils/form-field-helpers";
import { FieldValues } from "checkout-query-client/types/form-types";

export const runValidationRulesField = ({
  validators,
  validatorId,
  newValue,
  field,
}: {
  validators: Record<string, ControllerProps["rules"]>;
  validatorId: string;
  newValue: string;
  field: ControllerRenderProps<FieldValues<string>, string>;
}) => {
  let finalValue = newValue;
  if (newValue) {
    if (field.name.includes("billingAddressZip")) {
      finalValue = newValue.toUpperCase();
    }

    const maxLength = Number(validators[validatorId]?.["maxLength"]);
    if (maxLength && newValue.length > maxLength) {
      finalValue = newValue.substring(0, maxLength);
    }

    const pattern = validators[validatorId]?.["pattern"] as RegExp;
    if (pattern && !pattern.test(finalValue)) {
      // return to old value if it fails pattern match
      finalValue = field?.value ?? "";
    }
  }

  return finalValue;
};

export const runValidationRulesAutocomplete = ({
  validators,
  validatorId,
  newValue,
  field,
}: {
  validators: Record<string, ControllerProps["rules"]>;
  validatorId: string;
  newValue: string;
  field: string;
}) => {
  let finalValue = newValue;
  if (newValue) {
    if (field.includes("billingAddressZip")) {
      finalValue = newValue.toUpperCase();
    }

    const maxLength = Number(validators[validatorId]?.["maxLength"]);
    if (maxLength && newValue.length > maxLength) {
      finalValue = newValue.substring(0, maxLength);
    }

    const pattern = validators[validatorId]?.["pattern"] as RegExp;
    if (pattern && !pattern.test(finalValue)) {
      // return to old value if it fails pattern match
      finalValue = "";
    }
  }

  return finalValue;
};

export const getValidatorId = (
  fieldId: string,
  countryFieldValue: string | undefined
) => {
  return `${fieldId}${
    countrySpecificFields.includes(fieldId) &&
    ["US", "CA", "GB"].includes(countryFieldValue ?? "")
      ? countryFieldValue
      : ""
  }`;
};
